import { MutableState, Mutator, Tools } from 'final-form'

export const changeFieldValueMutator: Mutator = ([name, value]: any[], state: MutableState, { changeValue }: Tools) => {
  changeValue(state, name, (val: any): any => value)
}



// WEBPACK FOOTER //
// ./src/modules/forms/final-form-mutators.ts